import React, { useState, useEffect } from "react";
import HappyCustomerServices from "../../services/HappyCustomerServices";

function HappyCustomerUpdate({ happy, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    name: "",
    description: "",
    rating: "",
    video: "",
  });

  const [previewVideo, setPreviewVideo] = useState("");
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (happy) {
      setFormValues({
        name: happy?.name || "",
        description: happy?.description || "",
        rating: happy?.rating || "",
        video: happy?.video || "",
      });

      if (happy.video && happy.video.startsWith("http")) {
        setPreviewVideo(happy.video); // Video URL
      } else if (happy.video) {
        setPreviewVideo(`${process.env.REACT_APP_URL}${happy.video}`); // Uploaded video path
      }
    }
  }, [happy]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    // If updating video as a URL, set it directly
    if (name === "video" && value.startsWith("http")) {
      setFormValues({
        ...formValues,
        video: value,
      });
      setPreviewVideo(value); // Set preview to the entered URL
    } else {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploading(true);

    try {
      const formData = new FormData();
      formData.append("video", file);

      const response = await HappyCustomerServices.uploadVideo(formData);

      if (response && response.video) {
        const uploadedVideoPath = response.video.replace(/\\/g, "/"); // Normalize path
        const videoURL = `${process.env.REACT_APP_URL}${uploadedVideoPath}`;
        setFormValues((prevValues) => ({
          ...prevValues,
          video: uploadedVideoPath,
        }));
        setPreviewVideo(videoURL); // Set preview for uploaded file
      } else {
        alert("Failed to upload video. Please try again.");
      }
    } catch (error) {
      console.error("Video upload failed", error);
      alert("An error occurred during the video upload.");
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const { video, ...otherValues } = formValues;
      let payload = { ...otherValues };

      // Check if video is a URL or a file path
      if (video.startsWith("http")) {
        payload.video = video; // Save video URL
      } else {
        payload.video = video; // Save uploaded video path
      }

      await HappyCustomerServices.updateHappy(happy.id, payload);

      alert("Happy Customer updated successfully");
      onSuccess();
      closeModal();
    } catch (error) {
      console.error("Failed to update Happy Customer", error);
      alert("Failed to update Happy Customer");
    }
  };

  return (
    <div
      className="modal fade edit-box show d-block"
      id="editModal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Happy Customer</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              onClick={closeModal}
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Name</label>
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            value={formValues.name}
                            onChange={handleInputChange}
                            placeholder="New name"
                                        />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Rating</label>
                          <select
                            className="form-control"
                            value={formValues.rating}
                            onChange={handleInputChange}
                            name="rating"
                          >
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-12 col-sm-12">
                        <div className="input-field">
                          <label>Description</label>
                          <input
                            type="text"
                            name="description"
                            className="form-control"
                            value={formValues.description}
                            onChange={handleInputChange}
                            placeholder="New description"
                                        />
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <div className="input-field">
                          <label>Upload Image or Enter Image URL</label>

                          <input
                            type="text"
                            name="video"
                            className="form-control mb-3"
                            placeholder="Enter image URL"
                            value={formValues.video}
                            onChange={handleInputChange}
                          />

                          <input
                            type="file"
                            name="video"
                            className="form-control"
                            accept="image/*"
                            onChange={handleFileChange}
                            disabled={uploading}
                          />

                          {previewVideo && (
                            <div className="file-preview text-center mt-3">
                              <img
                                src={previewVideo}
                                alt="Preview"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "200px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                    </div>
                    <button
                      className="submit-green-btn mt-4"
                      type="submit"
                      disabled={uploading}
                    >
                      {uploading ? "Uploading..." : "Submit"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HappyCustomerUpdate;
